import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { directDebitTypes } from '@/configuration/pages/ConfigurationPage/constants'

import BACS from './BACS/BACS'
import SEPA from './SEPA/SEPA'
import SignMandateButton from './SignMandateButton/SignMandateButton'
import { descriptionText, titleText } from './constants'
import * as Styles from './styles'

const ReveniSubsidiary = ({
  subsidiary,
  bankAccounts,
  paymentMethodCreated,
  createPaymentMethod,
  creatingPaymentMethod,
  setPaymentMethodCreated,
  fetchBankAccounts,
}) => {
  const bankAccount = bankAccounts?.results?.find(account => account.id === subsidiary?.payment_method_id)
  const companyName = subsidiary?.company_name
  const taxId = subsidiary?.tax_id
  const address = subsidiary?.address
  const { t } = useTranslation()

  const onCreatePaymentMethod = () => {
    createPaymentMethod({ reveni_subsidiary_type: subsidiary?.type })
  }

  return (
    <Styles.Container>
      <Text type="titleM">{t(titleText?.[subsidiary.type]?.[subsidiary.direct_debit_scheme])}</Text>
      <Text type="bodyMRegular">{t(descriptionText?.[subsidiary.type])}</Text>
      {subsidiary?.direct_debit_scheme === directDebitTypes.SEPA && (
        <SEPA
          bankAccount={bankAccount}
          companyName={companyName}
          taxId={taxId}
          address={address}
          mandateButton={
            <SignMandateButton
              paymentMethodCreated={paymentMethodCreated}
              onCreatePaymentMethod={onCreatePaymentMethod}
              loading={creatingPaymentMethod}
              setPaymentMethodCreated={setPaymentMethodCreated}
              fetchBankAccounts={fetchBankAccounts}
              bankAccount={bankAccount}
            />
          }
        />
      )}
      {subsidiary?.direct_debit_scheme === directDebitTypes.BACS && (
        <BACS
          bankAccount={bankAccount}
          companyName={companyName}
          taxId={taxId}
          address={address}
          mandateButton={
            <SignMandateButton
              paymentMethodCreated={paymentMethodCreated}
              onCreatePaymentMethod={onCreatePaymentMethod}
              loading={creatingPaymentMethod}
              setPaymentMethodCreated={setPaymentMethodCreated}
              fetchBankAccounts={fetchBankAccounts}
              bankAccount={bankAccount}
            />
          }
        />
      )}
    </Styles.Container>
  )
}

export default ReveniSubsidiary
